import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Modal } from "reactstrap";
import "./index.css";
import { router } from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Assets/CSS/globalCSS.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Assets/SCSS/globalSCSS.scss";
import { RouterProvider } from "react-router-dom";
import {
  ToastContextProvider,
  UserInfoContextProvider,
  SuccessfullyMessageBarProvider,
  UserInfoContext,
  VersionUpdateMessageBarProvider,
} from "Context/CommonContext";
import ToastMessage from "Components/CommonComponents/ToastMessage";
import { MasterDataProvider } from "Context/MasterContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { EN_CLIENT_ID } from "utilFunctions/Constants/Constants";
import { ScreenSizeProvider } from "utilFunctions/CustomHooks/ScreenSizeContext";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { sendPWAEventToGTAG } from "utilFunctions/helperFunctions/analytics";
import {
  StudentContextProvider,
  StudentPerformanceContextProvider,
} from "Context/StudentContext";
import { GlobalSearchProvider } from "Context/GlobalSearchContext";
import IOSWalkthroughPWA from "utilFunctions/shared/IOSWalkthroughPWA";
import AndroidPWAPrompt from "utilFunctions/shared/AndroidPWAPrompt";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FacultyPerformanceContextProvider } from "Context/FacultyPerformanceContext";
import { SyllabusCompliancesContextProvider } from "Context/SyllabusCompliances";
import {
  LOPDashboardContextProvider,
  MyBranchContextProvider,
} from "Context/LOPDashboard";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { MyBatchContextProvider } from "Pages/MyBatches/MyBatch/Context/useMyBatchContext";
import { MyBatchProvider } from "Pages/DRS/Context/MyBatchContext";
// import ThemeProviderWrapper from "Theme/ThemeProviderWrapper";
const gClientId = EN_CLIENT_ID || "";

// Service worker registration
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

const AppRoot: React.FC = () => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [iosmodalOpen, setIosModalOpen] = useState<boolean>(false);
  const { screen }: any = useWindowSize();

  if (process.env.NODE_ENV === "production") {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    console.log = (..._args: any[]) => {};
  }

  useEffect(() => {
    const beforeInstallPromptHandler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      if (
        ["xs", "sm", "md"].includes(screen) &&
        !window.localStorage.getItem("appInstalled")
      ) {
        setModalOpen(true);
      }
    };

    window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);

    // Show the modal when the component mounts
    if (
      ["xs", "sm", "md"].includes(screen) &&
      !window.localStorage.getItem("appInstalled")
    ) {
      setModalOpen(true);
    }

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        beforeInstallPromptHandler
      );
    };
  }, [screen, userInfo]);
  useEffect(() => {
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    if (isStandalone) {
      // Send analytics event for PWA usage
      sendPWAEventToGTAG("pwa");
    } else {
      sendPWAEventToGTAG("browser");
    }
  }, []);
  const installApp = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === "accepted") {
          console.log("PWA installation accepted");
        } else {
          console.log("PWA installation declined");
        }
        setDeferredPrompt(null);
        setModalOpen(false); // Close the modal after installation attempt
      });
    }
  };
  useEffect(() => {
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    if (!isStandalone && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
      // Send analytics event for PWA usage
      setIosModalOpen(true);
    }
  }, []);

  const installLater = () => {
    setModalOpen(false); // Close the modal without installing
    setIosModalOpen(false);
  };
  console.log(userInfo, "useragent99");
  return (
    <React.StrictMode>
      <Provider store={store}>
        {/* <ThemeProviderWrapper> */}
        <MyBatchProvider>
          <ScreenSizeProvider>
            <MyBatchContextProvider>
              <GoogleOAuthProvider clientId={gClientId}>
                <GlobalSearchProvider>
                  <VersionUpdateMessageBarProvider>
                    <FacultyPerformanceContextProvider>
                      <LOPDashboardContextProvider>
                        <MyBranchContextProvider>
                          <SyllabusCompliancesContextProvider>
                            <StudentPerformanceContextProvider>
                              <StudentContextProvider>
                                <UserInfoContextProvider>
                                  <ToastContextProvider>
                                    <MasterDataProvider>
                                      <ToastMessage />
                                      <SuccessfullyMessageBarProvider>
                                        <RouterProvider router={router} />
                                        {deferredPrompt &&
                                          !/iPad|iPhone|iPod/.test(
                                            navigator.userAgent
                                          ) && (
                                            <Modal
                                              isOpen={modalOpen}
                                              toggle={() =>
                                                setModalOpen(!modalOpen)
                                              }
                                              className={"installModal"}
                                            >
                                              <AndroidPWAPrompt
                                                modalOpen={modalOpen}
                                                installApp={installApp}
                                                setModalOpen={setModalOpen}
                                                installLater={installLater}
                                              />
                                            </Modal>
                                          )}
                                        {iosmodalOpen &&
                                          /iPad|iPhone|iPod/.test(
                                            navigator.userAgent
                                          ) && (
                                            <Modal
                                              isOpen={modalOpen}
                                              toggle={() =>
                                                setIosModalOpen(!iosmodalOpen)
                                              }
                                              className={"installModaliOs"}
                                            >
                                              <IOSWalkthroughPWA
                                                modalOpen={iosmodalOpen}
                                                installApp={installApp}
                                                setModalOpen={setIosModalOpen}
                                                installLater={installLater}
                                              />
                                            </Modal>
                                          )}
                                      </SuccessfullyMessageBarProvider>
                                    </MasterDataProvider>
                                  </ToastContextProvider>
                                </UserInfoContextProvider>
                              </StudentContextProvider>
                            </StudentPerformanceContextProvider>
                          </SyllabusCompliancesContextProvider>
                        </MyBranchContextProvider>
                      </LOPDashboardContextProvider>
                    </FacultyPerformanceContextProvider>
                  </VersionUpdateMessageBarProvider>
                </GlobalSearchProvider>
              </GoogleOAuthProvider>
            </MyBatchContextProvider>
          </ScreenSizeProvider>
        </MyBatchProvider>
        {/* </ThemeProviderWrapper> */}
      </Provider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<AppRoot />);

reportWebVitals();
// #E5F6FF
